import React from "react";

import {
  MenuList,
  Paper,
  Popper,
  MenuItem,
  ClickAwayListener,
  Button,
} from "@mui/material";

import { ExpandMore } from "@mui/icons-material";

export const DropdownMenu = ({
  currentOption,
  setCurrentOption,
  optionsArr,
  size = "large",
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);

  const handleClick = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClose = (e) => {
    const textContent = e.target.textContent;

    // because we're using an off-click listener to utilize the paper wrapper on the menu (so we don't disable scrolling),
    // we need to make sure setting state only happens if the user clicks on a menuItem
    if (e.target.dataset.menuitem === "true") setCurrentOption(textContent);

    setAnchorEl(null);
  };

  return (
    <>
      <Button
        id="composition-button"
        aria-controls={open ? "composition-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
        endIcon={<ExpandMore />}
        color="fade"
        size={size}
        sx={{
          ...(size === "small" && {
            height: "min-content",
          }),
        }}
      >
        {currentOption}
      </Button>
      <Popper
        open={open}
        anchorEl={anchorEl}
        role={undefined}
        placement="bottom"
      >
        <Paper>
          <ClickAwayListener onClickAway={handleClose}>
            <MenuList aria-labelledby="composition-button">
              {optionsArr.map((label) => (
                <MenuItem
                  key={label}
                  selected={currentOption == label}
                  onClick={handleClose}
                  data-menuitem={true}
                >
                  {label}
                </MenuItem>
              ))}
            </MenuList>
          </ClickAwayListener>
        </Paper>
      </Popper>
    </>
  );
};
